import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css?v=1';
import App from './App';
import Login from './pages/Login.jsx';
import SelfRaiseEyeTicket from './pages/SelfRaiseEyeTicket.jsx';
import SelfRaiseEyeTicketComplete from './pages/SelfRaiseEyeTicketComplete.jsx';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import ProtectedRoute from './ProtectedRoute';
import ForgotPassword from './pages/ForgotPassword.jsx';
import Register from './pages/Register.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/myeyeticket" element={<SelfRaiseEyeTicket />} />
      <Route path="/myeyeticket-complete" element={<SelfRaiseEyeTicketComplete />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/*" element={<ProtectedRoute element={App} />} />
    </Routes>
  </Router>
);

serviceWorkerRegistration.register();
reportWebVitals();
